import { shade, transparentize } from 'polished';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  position: relative;
  max-width: 960px;
  margin-right: auto;
  margin-left: auto;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
`;

export const ImportFileContainer = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 1em 0 0 0;
`;

export const FooterContainer = styled.section`
  width: 100%;
  margin: 2rem 0rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 768px) {
    width: 100%;
  }

  p {
    display: flex;
    align-items: center;
    font-size: 12px;
    line-height: 18px;
    color: ${props => props.theme.secondaryColor};
    pointer-events: none;

    svg {
      margin-right: 5px;
      width: 24px;
      color: ${props => props.theme.secondaryColor};
    }
  }
`;
export const FooterContainerModal = styled.section`
  width: 100%;
  margin-top: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column-reverse;

  @media (max-width: 768px) {
    width: 100%;
  }

  p {
    display: flex;
    align-items: center;
    font-size: 12px;
    line-height: 18px;
    color: ${props => props.theme.secondaryColor};
    pointer-events: none;
    margin-top: 2rem;

    svg {
      margin-right: 5px;
      width: 24px;
      color: ${props => props.theme.secondaryColor};
    }
  }
`;

export const Label = styled.label`
  display: block;
  width: 100%;
  min-height: 1rem;
  font-size: 0.9rem;
  color: rgb(135, 134, 139);
  margin-bottom: 0.5rem;
`;

export const FileWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HeaderTable = styled.header`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  label {
    font-size: 1.2rem;
  }

  > div {
    display: flex;
    align-items: center;

    .badge {
      padding: 0.3rem 1rem;
      border-radius: 4px;
      font-weight: 500;
      pointer-events: none;
      user-select: none;

      &:not(:first-child) {
        margin-left: 1.4rem;
      }
    }

    .success {
      background: ${transparentize(0.8, '#00de9f')};
      color: #00de9f;
    }

    .error {
      background: ${transparentize(0.8, '#910f2d')};
      border: 1px solid #910f2d;
      color: #910f2d;
    }

    .progress {
      background: ${transparentize(0.8, '#F7D56D')};
      color: #f7d56d;
    }
  }

  button {
    .rotate {
      transition: all 0.5s ease-in-out;
      transform: rotate(180deg);
    }
  }
`;

export const TableContainer = styled.section`
  > div {
    margin: 2rem 0rem;
    border-radius: 4px;

    table {
      width: 100%;
      border-collapse: collapse;

      tr {
        &:nth-of-type(odd) {
          background: #f3f3f3;
        }

        &:hover {
          color: #166649;
        }

        &:last-child {
          border-bottom: 3px solid #166649;
        }
      }

      th {
        background: ${props => props.theme.primaryColor};
        color: #fff;
        padding: 1.3rem 0.75rem;
        text-align: left;
        font-weight: 500;
        border: 1px solid #166649;
        user-select: none;

        div {
          display: flex;
          align-items: center;
          user-select: none;
          cursor: pointer;

          svg {
            transition: 0.3s ease-out;

            &.active {
              transform: rotate(-180deg);
            }
          }
        }
      }

      td {
        padding: 0rem 0.75rem;
        text-align: left;
        font-size: 16px;
        height: 6rem;
        max-width: 140px;
        word-break: break-word;
        user-select: none;

        /* &:nth-child(1) {
          display: none;
        } */

        > div {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          white-space: nowrap;
        }

        p {
          cursor: pointer;
          position: relative;
          word-wrap: break-word;
          font-size: 14px;
          margin-top: 0.5rem;

          @media (max-width: 768px) {
            text-align: right;
            cursor: auto;
          }

          .tooltip {
            display: none;
          }

          @media (min-width: 768px) {
            .tooltip {
              max-width: 550px;
              display: block;
              visibility: hidden;
              background-color: #fff;
              color: #555;
              border: 1px solid #ccc;
              text-align: center;
              border-radius: 4px;
              padding: 0.6rem 1rem;
              transform: translateY(-20px);
              transition: 0.3s ease-in-out;
              opacity: 0;
              position: absolute;
              z-index: 1;
              text-transform: capitalize !important;
              font-size: 0.9rem;
              bottom: calc(100% + 15px);
              left: -10px;
              box-shadow: 0px 0px 60px 0px rgba(0, 0, 0, 0.1);
              cursor: auto;

              &:after {
                content: '';
                position: absolute;
                bottom: -11px;
                left: 50%;
                margin-top: -5px;
                border-width: 5px;
                border-style: solid;
                border-color: #ccc transparent transparent transparent;
              }
            }

            &:hover .tooltip {
              transform: translateX(0px);
              visibility: visible;
              opacity: 1;
            }
          }
        }

        ul {
          display: flex;
          /* max-width: 100px; */
          flex-wrap: wrap;

          li {
            display: inline-block;

            &:after {
              display: inline-block;
              white-space: pre;
              content: ', ';
            }

            &:last-child:after {
              display: inline-block;
              white-space: pre;
              content: '';
              color: #4285f4;
            }
          }
        }
      }

      @media (max-width: 992px) {
        width: 100%;

        table,
        thead,
        tbody,
        th,
        td,
        tr {
          display: block;
          max-width: unset;
        }

        thead tr {
          position: absolute;
          top: -9999px;
          left: -9999px;
        }

        tr {
          border: 1px solid #ccc;
          margin: 1rem 0rem;
        }

        td {
          border: none;
          border-bottom: 1px solid #eee;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: space-between;

          ul {
            display: flex;
            justify-content: flex-end;
            text-align: right;
          }
        }

        td:before {
          padding-right: 10px;
          content: attr(data-heading);
          color: ${props => props.theme.textColor};
          font-weight: bold;
        }
      }
    }
  }
`;

export const LoadingData = styled.div`
  width: 100%;
  margin: 2rem 12px;
`;

interface BadgeProps {
  onClick?:
    | ((event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void)
    | undefined;
  type?: 'SUCESSO' | 'ERRO' | 'PENDENTE' | 'DEFAULT' | 'PROCESSANDO';
}

const messageColors = {
  SUCESSO: '#00de9f',
  ERRO: '#910F2D',
  PENDENTE: '#F7D56D',
  PROCESSANDO: '#B89E51',
  DEFAULT: '#c4c4c4',
};

export const Badge = styled.span<BadgeProps>`
  position: relative;
  background: ${({ type }: BadgeProps) =>
    `${transparentize(0.8, messageColors[type || 'DEFAULT'])}`};
  color: ${({ type }: BadgeProps) =>
    `${shade(0.2, messageColors[type || 'DEFAULT'])}`};
  padding: 0.3rem 0.8rem;
  font-size: 14px;
  border-radius: 0.35rem;

  /* @keyframes ripples {
    to {
      box-shadow: 0 0 0 4px rgba(145, 15, 45, 0.2),
        0 0 0 8px rgba(145, 15, 45, 0.2), 0 0 0 12px rgba(145, 15, 45, 0.2),
        0 0 0 16px rgba(145, 15, 45, 0);
    }
  } */

  @keyframes bounce {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }

  ${({ type }: BadgeProps) =>
    type === 'ERRO' &&
    css`
      border: 1px solid #910f2d;
      /* animation: bounce 2s linear infinite; */

      :before {
        position: absolute;
        content: '';
        top: 0px;
        bottom: 0px;
        left: 0px;
        right: 0px;
        border-radius: 0.3rem;
        /* box-shadow: 0 0 rgba(145, 15, 45, 0.2), 0 0 0 4px rgba(145, 15, 45, 0.2),
          0 0 0 8px rgba(145, 15, 45, 0.2), 0 0 0 12px rgba(145, 15, 45, 0.2); */
        /* z-index: -1; */
        /* animation: ripples 1s linear infinite; */
      }
    `}

  font-weight: 500;
  pointer-events: ${({ type }: BadgeProps) =>
    type !== 'ERRO' ? 'none' : undefined};
  cursor: ${({ type }: BadgeProps) =>
    type === 'ERRO' ? 'pointer' : undefined};
  margin: 0rem 0.5rem 0rem 0rem;

  &:not(:first-child) {
    margin: 0rem 0.5rem;
  }
`;

export const BadgeError = styled.span<BadgeProps>`
  position: relative;
  color: ${({ type }: BadgeProps) =>
    `${shade(0.2, messageColors[type || 'DEFAULT'])}`};
  padding: 0.3rem 0.8rem;
  font-size: 14px;
  border-radius: 0.35rem;
  user-select: none;
  font-weight: 500;
  margin: 0rem 0.5rem 0rem 0rem;
  &:not(:first-child) {
    margin: 0rem 0.5rem;
  }
`;

export const List = styled.ul`
  margin: 2rem 0rem;
  //ajustar
  .list-content-secondary {
    color: #000;
    margin-bottom: 1rem;
    background: ${transparentize(0.8, '#910f2d')};
    border-left: 0.5rem solid ${props => props.theme.error};
    padding: 0.2rem;
  }

  li {
    position: relative;
    margin-bottom: 1rem;
    padding-left: 1.3rem;

    b {
      color: #000;
    }

    .list-content-principal {
      font-size: 0.8rem;
      color: ${props => props.theme.error};
    }

    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 2px;
      height: 1rem;
      width: 1rem;
      background: ${props => props.theme.primaryColor};
      border-radius: 50%;
    }

    &:after {
      content: '';
      position: absolute;
      left: 3px;
      top: 5px;
      height: 10px;
      width: 10px;
      background: #fff;
      border-radius: 50%;
    }
  }

  &:last-child {
    margin: 2rem 0rem 0rem 0rem;
  }
`;
